import * as React from 'react';
import { SVGS } from '../../assets/svgs.react';

interface SeatComponentProps {
    type: string;
    occupied: boolean;
    id?: string;
}

export const SeatComponent = (props: SeatComponentProps) => {
    const occupiedStyle: string = props.occupied
        ? 'occupied'
        : '';

    return (
        <div
            className="seat-component"
        >
            {(props.id === '0000-01') || (props.id === '0000-03')
                ? (
                <div
                    className={'icon-wrapper ' + occupiedStyle}
                >
                    {SVGS.circle}
                    <div
                        className="handicap-wrapper"
                    >
                        {SVGS.handicap}
                    </div>
                    {props.occupied ? SVGS.cross : ''}
                </div>
            ) : (
                <div
                    className={'icon-wrapper ' + occupiedStyle}
                >
                    {SVGS.circle}
                    {props.occupied ? SVGS.cross : ''}
                </div>
            )}
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/grid/seat.component.tsx